import { mergeClasses } from "@griffel/react";
import { getRibbonButtonSizedStyles } from "../../next/commonRibbonButtonStyles";
import {
  useRibbonToggleButtonStyles,
  RibbonToggleButtonState,
} from "../../RibbonToggleButton/next";
import {
  useSplitButtonPrimaryButtonIconStyles,
  useSplitButtonPrimaryButtonRootStyles,
} from "./useRibbonSplitButtonPrimaryButtonStyles";

export const useRibbonSplitButtonPrimaryToggleButtonStyles = (
  state: RibbonToggleButtonState
) => {
  const rootStyles = useSplitButtonPrimaryButtonRootStyles();
  const iconStyles = useSplitButtonPrimaryButtonIconStyles();

  state.root.className = mergeClasses(
    rootStyles.base,
    getRibbonButtonSizedStyles(state.size, rootStyles),
    state.root.className
  );

  if (state.icon) {
    state.icon.className = mergeClasses(
      iconStyles.base,
      getRibbonButtonSizedStyles(state.size, iconStyles),
      state.icon.className
    );
  }
  useRibbonToggleButtonStyles(state as RibbonToggleButtonState);
  return state;
};
